module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('groupPages.modules.videos.title')))]), _c('ul', {
    staticClass: "videos"
  }, _vm._l((_vm.items), function(video) {
    return _c('li', [(video.extension == ':youtube') ? _c('group-page-link-youtube', {
      attrs: {
        "link": video
      }
    }) : _vm._e(), (video.extension == ':dailymotion') ? _c('vue-groupPage-link-dailymotion', {
      attrs: {
        "link": video
      }
    }) : _vm._e(), (_vm.openEditor) ? _c('i', {
      staticClass: "text-danger trash fa fa-trash",
      on: {
        "click": function($event) {
          return _vm.removeLink(video)
        }
      }
    }) : _vm._e()], 1)
  }), 0), (_vm.openEditor) ? _c('form', {
    staticClass: "pt",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addUrl($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('groupPages.modules.videos.add')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUrl),
      expression: "newUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('groupPages.modules.videos.placeholder')
    },
    domProps: {
      "value": (_vm.newUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUrl = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('globals.add')))]), _c('div', {
    staticClass: "cf"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4c5558e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPageVideos.vue
// module id = 1288
// module chunks = 2